import { FC } from 'react'
import styles from './RequestForRegistrationMainInformation.module.css'
import { ItemInfo } from '../ItemInfo/ItemInfo'
import { RegistrationRequestType } from '../../redux/actions/types'
import { createRoleCompanyFromEnToRu } from '../../utils/createRoleForRegister'

export type RequestForRegistrationMainInformationPropsType = {
  requestData: RegistrationRequestType
}

const RequestForRegistrationMainInformation: FC<RequestForRegistrationMainInformationPropsType> = ({
  requestData,
}) => {
  return (
    <div className={styles.mainInformationBlock}>
      <div className={styles.header}>
        <h2 className={styles.title}>Основная информация</h2>
      </div>
      <div className={styles.container}>
        <ItemInfo title='Название организации' value={requestData.companyName} />
        <ItemInfo title='ИНН' value={requestData.inn} />
        <ItemInfo title='Роль' value={createRoleCompanyFromEnToRu(requestData.role) ?? ''} />
        <ItemInfo title='Город' value={requestData.city} />
        <ItemInfo title='Адрес' value={requestData.address} />
        <ItemInfo title='ФИО контактного лица' value={requestData.contactFullName} />
        <ItemInfo title='Телефон контактного лица' value={requestData.contactPhone} />
        <ItemInfo title='Электронная почта/Логин' value={requestData.email} />
        <ItemInfo title='Пароль' value={requestData.password} />
      </div>
    </div>
  )
}

export default RequestForRegistrationMainInformation
